"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_placeholder_loader_1 = require("@hotelplan/components.common.placeholder-loader");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const TextLineSkeleton = props => {
    const { width } = props;
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    return (react_1.default.createElement(components_common_placeholder_loader_1.PlaceholderLoader, { uid: `TextLineSkeleton_${width}`, width: width, height: mobile ? 18 : 25, speed: 2, style: { width: `${width}px`, height: '18px' } },
        react_1.default.createElement("rect", { width: width, height: mobile ? 18 : 25, rx: 8 })));
};
exports.default = TextLineSkeleton;
//# sourceMappingURL=TextLineSkeleton.js.map